<template>
  <div class="flex flex-col items-center text-center">
    <!-- Newest entry: hero treatment -->
    <div class="text-5xl my-4">{{ latest.emoji }}</div>
    <h2 class="text-2xl mb-3">{{ latest.title }}</h2>
    <p class="mb-6">{{ latest.body }}</p>

    <!-- Optional call-to-action link (e.g. the "send an idea" typebot). -->
    <a v-if="latest.link" :href="latest.link.href" target="_blank" rel="noopener"
       class="inline-block mb-6 bg-gradient-to-r from-green-400 to-teal-400 hover:bg-green-500 text-gray-900 font-semibold px-5 py-2 rounded">
      {{ latest.link.label }}
    </a>

    <!-- Older entries: compact history -->
    <div v-if="older.length" class="w-full text-left border-t border-gray-700 pt-4">
      <h3 class="text-sm uppercase tracking-wide text-gray-400 mb-3">Earlier updates</h3>
      <div class="space-y-4">
        <div v-for="entry in older" :key="entry.id" class="flex gap-3">
          <div class="text-xl leading-none">{{ entry.emoji }}</div>
          <div>
            <div class="flex items-baseline gap-2">
              <span class="font-semibold">{{ entry.title }}</span>
              <span class="text-xs text-gray-500">{{ formatDate(entry.date) }}</span>
            </div>
            <p class="text-sm text-gray-300">{{ entry.body }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed} from "vue";
import {changelog} from "../data/changelog.js";

const latest = computed(() => changelog[0]);
const older = computed(() => changelog.slice(1));

function formatDate(date) {
  return new Date(date).toLocaleDateString(undefined, {month: 'short', year: 'numeric'});
}
</script>
